import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// This should be abstracted to a user settings store in the future to parcel out some of those settings and filters from the negotiation obj

const STORAGE_KEY = 'offerOptionsDefaults';

export const OFFER_DELIVERY_MODES = /** @type {const} */ ({
  OFFERS_ONLY: 'offers',
  INDIVIDUAL: 'individual',
  BATCH: 'batch',
});

const DEFAULTS = {
  includeCompsInOffersSpreadsheet: true,
  workupDeliveryMode: OFFER_DELIVERY_MODES.OFFERS_ONLY,
  workupReportType: 'fnmaSummary',
};

export const workupOptionsFromDefaults = (defaults) => {
  const include = !!defaults?.includeCompsInOffersSpreadsheet;
  const mode = defaults?.workupDeliveryMode || OFFER_DELIVERY_MODES.OFFERS_ONLY;
  if (!include || mode === OFFER_DELIVERY_MODES.OFFERS_ONLY) return { includeWorkups: false };
  return { includeWorkups: true, type: mode === OFFER_DELIVERY_MODES.BATCH ? 'batch' : 'individual' };
};

export const useOfferOptionsStore = create(
  persist(
    (set, get) => ({
      ...DEFAULTS,
      setIncludeCompsInOffersSpreadsheet: (value) =>
        set((state) => {
          const on = !!value;
          return on
            ? { includeCompsInOffersSpreadsheet: true }
            : { includeCompsInOffersSpreadsheet: false, workupDeliveryMode: OFFER_DELIVERY_MODES.OFFERS_ONLY };
        }),
      setWorkupDeliveryMode: (mode) =>
        set(() => ({
          workupDeliveryMode: mode || OFFER_DELIVERY_MODES.OFFERS_ONLY,
        })),
      setWorkupReportType: (value) => set(() => ({ workupReportType: value || 'fnmaSummary' })),
      setOfferOptions: (partial) => set(() => ({ ...partial })),
      resetOfferOptions: () => set(() => ({ ...DEFAULTS })),
      getWorkupOptions: () => workupOptionsFromDefaults(get()),
    }),
    {
      name: STORAGE_KEY,
      version: 1,
      partialize: (s) => ({
        includeCompsInOffersSpreadsheet: s.includeCompsInOffersSpreadsheet,
        workupDeliveryMode: s.workupDeliveryMode,
        workupReportType: s.workupReportType,
      }),
    }
  )
);

